import { createAsyncThunk } from "@reduxjs/toolkit";
import { agentsRegister, baseUrl } from "../../../store/APILinks";

export const AgentRegister = createAsyncThunk("agent/register", async (agentData) => {
  const response = await fetch(`${baseUrl}/${agentsRegister}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(agentData),
  });
  return response.json();
});

export const AgentRegisterHandler = (builder) => {
  builder.addCase(AgentRegister.pending, (state) => {
    state.loading = true;
  });
  builder.addCase(AgentRegister.fulfilled, (state, action) => {
    state.loading = false;
    state.agentData = action.payload;
    state.error = null;
  });
  builder.addCase(AgentRegister.rejected, (state, action) => {
    state.loading = false;
    state.error = action.error.message;
  });
};
